<template>
	<div>
		<div v-if="!localEmzameContractAuthorizationItem || !localEmzameContractAuthorizationItem.contract">
			<div class="red--text text-ecnter mb-2">لطفا برای آماده سازی قرارداد جهت امضا بر روی دکمه "ارسال به سامانه امضامی" کلیک نمایید .</div>
			<div class="text-center">
				<div class="text-center mb-2" v-if="area === 'admin'">
					<v-btn small outlined color="primary" @click="manualDialog = true" width="200" class="">
						ثبت اطلاعات تکمیلی
					</v-btn>
				</div>
				<div class="text-center">
					<v-btn small outlined color="primary" @click="createAndSend()" width="200" :loading="sendLoading">
						ارسال به سامانه امضامی
					</v-btn>
				</div>
			</div>
		</div>
		<div v-if="localEmzameContractAuthorizationItem && localEmzameContractAuthorizationItem.contract">
			<v-row>
				<v-col cols="12" md="2">
					<v-badge :content="localEmzameContractAuthorizationItem.contract.status === 'accept' ? '✓' : ''" location="top start" offset-x="10" :color="localEmzameContractAuthorizationItem.contract.status === 'accept' ? 'success' : 'transparent'">
						<v-btn outlined :color="localEmzameContractAuthorizationItem.contract.status === 'accept' ? 'success' : 'grey'" icon="mdi-fingerprint">
							<v-icon v-if="localEmzameContractAuthorizationItem.contract.status === 'accept'">mdi-fingerprint</v-icon>
							<v-icon v-else>mdi-fingerprint-off</v-icon>
						</v-btn>
					</v-badge>
				</v-col>
				<v-col cols="12" md="8" class="pr-0">
					<div class="text-right">{{ localEmzameContractAuthorizationItem.contract.status_str }}</div>
					<div class="" v-if="localEmzameContractAuthorizationItem.contract.collaborator.length">
						<div class="d-flex" v-for="collaborator in localEmzameContractAuthorizationItem.contract.collaborator" :key="collaborator.nationalCode">
							<v-icon size="small" :color="statusIconColor(collaborator.status)">
								{{ statusIcon(collaborator.status) }}
							</v-icon>

							<small class="grey--text text--darken-3">کد ملی:</small>
							<small class="grey--text ml-3">{{ collaborator.nationalCode }}</small>

							<small class="grey--text text--darken-3">نام و نام خانوادگی:</small>
							<small class="grey--text ml-3">{{ collaborator.fullName }}</small>

							<small class="grey--text text--darken-3">وضعیت امضا‍:</small>
							<small class="grey--text ml-3">{{ collaborator.status_str }}</small>

						</div>
					</div>
				</v-col>
				<v-col cols="12" md="2" class="d-flex flex-column align-center">
					<v-btn small outlined color="primary" @click="selectMemberDialog = true" class="mb-2">
						دریافت آخرین وضعیت
					</v-btn>
					<v-btn small outlined color="primary" @click="contractDialog = true">
						مشاهده قرارداد
					</v-btn>
					<v-btn v-if="['admin'].includes(area)" small outlined color="primary" @click="contractDialog = true">
						ثبت اطلاعات تکمیلی
					</v-btn>
				</v-col>
			</v-row>
			<div class="mt-2 text-justify contract" v-if="localEmzameContractAuthorizationItem.tag" v-html="localEmzameContractAuthorizationItem.tag">

			</div>
		</div>

		<v-dialog v-model="contractDialog" max-width="1600px">
			<v-card color="#eee">
				<v-card-title>
					<div>
						<span class="headline">اطلاعات قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="contractDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<ThirdPersonContractDetail v-if="contractDialog" :area="area" :localEmzameContractAuthorizationItem="localEmzameContractAuthorizationItem" :mobile="mobile" @updated="$emit('updated')" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="manualDialog" max-width="500px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">اطلاعات دستی قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="manualDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div v-if="manualFields.length" class="mt-5">
						<v-text-field v-for="(field, index) in manualFields" :key="field.id || index" v-model="field.value" :label="field.label" dense outlined />
					</div>
					<div v-else class="text-center grey--text">
						موردی برای نمایش وجود ندارد.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="manualDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" :loading="submitManualTagsLoading" @click="submitManualTags">به روز رسانی
						متن قرارداد</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="alertDialog" max-width="450px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">توجه</span>
					</div>
					<v-spacer />
					<v-btn @click="alertDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div class="text-justify red--text">
						کاربر گرامی، درخواست امضای قرارداد شما به سامانه امضامی ارسال شد. هم اکنون پیامک حاوی
						لینک امضا از سامانه امضامی برای شما ارسال خواهد شد. لطفا از طریق لینک ارسالی اقدام به
						امضای قرارداد نمایید.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn color="primary" @click="alertDialog = false">
						متوجه شدم
					</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { auth } from '@/store/modules'
	import { cloneDeep } from 'lodash'

	export default {
		name: 'DigitalSignEmzame',
		props: {
			auth: { type: Object, default: null },
			emzameContractAuthorizationItem: { type: Object, default: null },
			area: { type: String, default: 'member' },
			memberId: { type: Number },
		},
		data() {
			return {
				submitManualTagsLoading: false,
				manualDialog: false,
				contractDialog: false,
				manualFields: [],
				alertDialog: false,
				sendLoading: false,
				localEmzameContractAuthorizationItem: null
			}
		},
		watch: {
			emzameContractAuthorizationItem: {
				handler(val) {
					this.localEmzameContractAuthorizationItem = val
				},
				deep: true,
			}
		},
		components: {
		},
		computed: {

		},
		mounted() {

		},
		methods: {
			extractManualFields(description) {
				const fields = []
				if (!description) {
					this.manualFields = fields
					return
				}
				const regex = /\{manual:"([^"]+)"\}/g
				const prevFields = this.manualFields || []
				let match
				while ((match = regex.exec(description)) !== null) {
					const label = match[1]
					const index = fields.length
					fields.push({
						id: `${match.index}-${label}-${index}`,
						label,
						value: prevFields[index]?.value || ''
					})
				}
				this.manualFields = fields
			},
			submitManualTags() {
				this.submitManualTagsLoading = true
				const manualFieldsObj = this.manualFields.reduce((acc, field) => {
					acc[field.label] = field.value
					return acc
				}, {})
				api.post('admin/UserLoanRequestAuthorizationItem/UpdateDigitalSignDescription/', { manualFields: manualFieldsObj, userLoanRequestAuthorizationItemId: this.auth.id })
					.then(response => {
						this.manualDialog = false
						toast.success('اطلاعات قرارداد با موفقیت ثبت شد.')
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.submitManualTagsLoading = false
					})
			},
			statusIconColor(status) {
				switch (status) {
					case 'accept':
						return 'green'
					case 'reject':
						return 'red'
					case 'readyForSign':
						return 'orange'
					case 'waitForOtherSigners':
						return 'orange'
					case 'expired':
						return 'grey'
					default:
						return 'orange'
				}
			},
			statusIcon(status) {
				switch (status) {
					case 'accept':
						return 'mdi-check'
					case 'reject':
						return 'mdi-close'
					case 'readyForSign':
						return 'mdi-timer-sand'
					case 'waitForOtherSigners':
						return 'mdi-timer-sand'
					case 'expired':
						return 'mdi-clock-alert-outline'
					default:
						return 'mdi-timer-sand'
				}
			},
			createIfRequired() {
				if (this.localEmzameContractAuthorizationItem?.contract)
					return
				console.log('aaaaaa')
				let data = {
					authorizationItemId: this.auth.authorizationItem.id,
					userLoanRequestAuthorizationItemId: this.auth.id,
					userLoanId: null,
					user: { id: this.memberId }
				}
				return api.post(`${this.area}/EmzameContractAuthorizationItem/Create/`, data)
			},
			async createAndSend() {
				this.sendLoading = true
				try {
					this.localEmzameContractAuthorizationItem.id = await this.createIfRequired()
				} catch (error) {
					this.sendLoading = false
					toast.error(error.message || 'خطا در ایجاد امضا')
					return
				}
				api.post(`${this.area}/EmzameContractAuthorizationItem/SendContractToEmzame/${this.localEmzameContractAuthorizationItem.id}`, {})
					.then(response => {
						this.manualDialog = false
						toast.success('اطلاعات قرارداد با موفقیت ثبت شد.')
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.sendLoading = false
						this.submitManualTagsLoading = false
					})
			}
		}
	}
</script>
<style scoped>
	.contract b {
		font-weight: 900;
		border-bottom: 1px dotted blue;
		color: blue;
	}
</style>
